import { middlewareGateway } from '~/gateway/middleware.gateway'
import { getErrorWithMessage } from '~/utils/errorUtils'

export function useRecaptcha() {
  const recaptchaKey = useRuntimeConfig().public.GOOGLE_RECAPTCHA_KEY as string

  const loadRecaptcha = () => {
    return new Promise((resolve, reject) => {
      if (window.grecaptcha) {
        resolve(window.grecaptcha)
        return
      }

      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaKey}`
      script.defer = true
      script.onload = () => resolve(window.grecaptcha)
      script.onerror = reject
      document.head.appendChild(script)
    })
  }

  const getRecaptchaToken = async (grecaptcha?: typeof window.grecaptcha, action?: string) => {
    if (!grecaptcha) {
      grecaptcha = (await loadRecaptcha()) as typeof window.grecaptcha
    }
    await new Promise<void>((resolve) => {
      grecaptcha?.enterprise.ready(resolve)
    })

    const token = await grecaptcha?.enterprise.execute(recaptchaKey, action ? { action } : undefined)
    return token
  }

  const validateRecaptchaToken = async (token: string) => {
    const response = await middlewareGateway('/next-gen/google/recaptcha/validate', {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ token }),
    }).catch((e) => {
      return getErrorWithMessage(e)
    })
    return response
  }

  return {
    loadRecaptcha,
    getRecaptchaToken,
    validateRecaptchaToken,
  }
}
